import { connect } from 'react-redux';
import App, { AppProps } from './App';
import { AppThunkAction, AppThunkDispatch, ApplicationState } from '../store';
import { loadBaseData } from '../store/session/actions';
 
const onAppLoad = () : AppThunkAction<Promise<void>> => {
    return async (dispatch) => {
        dispatch(loadBaseData())
    }
}

const mapDispatchToProps = (dispatch: AppThunkDispatch): AppProps => ({
    onLoad: () => dispatch(onAppLoad()),
});

export default connect<{}, AppProps, void, ApplicationState>(
    null,
    mapDispatchToProps,
)(App as any);